"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var $ = require("jquery");
require("fullcalendar");
var CalendarComponent = (function () {
    function CalendarComponent(element) {
        this.element = element;
        this.initialized = new core_1.EventEmitter();
    }
    CalendarComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        setTimeout(function () {
            // console.log("100ms after ngAfterViewInit ");
            $('angular2-fullcalendar').fullCalendar(_this.options);
            _this.initialized.emit(true);
        }, 100);
    };
    CalendarComponent.prototype.fullCalendar = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!args) {
            return;
        }
        switch (args.length) {
            case 0:
                return;
            case 1:
                return $(this.element.nativeElement).fullCalendar(args[0]);
            case 2:
                return $(this.element.nativeElement).fullCalendar(args[0], args[1]);
            case 3:
                return $(this.element.nativeElement).fullCalendar(args[0], args[1], args[2]);
        }
    };
    return CalendarComponent;
}());
CalendarComponent.decorators = [
    { type: core_1.Component, args: [{
                template: '<div></div>',
                selector: 'angular2-fullcalendar'
            },] },
];
/** @nocollapse */
CalendarComponent.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
]; };
CalendarComponent.propDecorators = {
    'options': [{ type: core_1.Input },],
    'initialized': [{ type: core_1.Output },],
};
exports.CalendarComponent = CalendarComponent;
//# sourceMappingURL=calendar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ap-angular2-fullcalendar/src/calendar/calendar.js
// module id = 134
// module chunks = 3